import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import debounce from 'lodash/debounce';

import { Loading } from 'uikit/loaders';
import Form from './form';

import FormContainer from '../containers/formContainer';

import styles from '../styles/autoSaveMagicForm.module.scss';

const AutoSaveMagicForm = ({
  autoSaveDelay = 1000,
  className = '',
  model,
  onAutoSave = () => {},
  onError = () => {},
  onFormUpdate = () => {},
  schema,
}) => {
  const [isSubmittingForm, setSubmittingForm] = useState(false);
  const [isModelModified, setIsModelModified] = useState(false);

  const saveForm = async (updatedModel) => {
    setSubmittingForm(true);
    try {
      await onAutoSave(updatedModel);
      setIsModelModified(false);
    } catch (error) {
      onError(error);
    }
    setSubmittingForm(false);
  };

  const debouncedSaveForm = useCallback(debounce(saveForm, autoSaveDelay), []);

  const handleFormUpdate = (onFormUpdateArgs) => {
    const { update, hasError } = onFormUpdateArgs;
    const updatedModel = { ...model, ...update };

    onFormUpdate(onFormUpdateArgs);
    if (!hasError) {
      setIsModelModified(true);
      debouncedSaveForm(updatedModel);
    }
  };

  return (
    <section className={classnames(styles.element, className, {
      [styles.isModelModified]: isModelModified,
    })}
    >
      <div className={styles.formContainer}>
        <FormContainer
          model={model}
          schema={schema}
          onUpdate={handleFormUpdate}
        />
      </div>
      {(isSubmittingForm) && <Loading className={styles.loading} />}
    </section>
  );
};

AutoSaveMagicForm.propTypes = {
  className: PropTypes.string,
  autoSaveDelay: PropTypes.number,
  onFormUpdate: PropTypes.func,
  onAutoSave: PropTypes.func,
  model: PropTypes.objectOf(PropTypes.any).isRequired,
  schema: PropTypes.objectOf(PropTypes.any).isRequired,
  onError: PropTypes.func,
};

export default AutoSaveMagicForm;
